import "shared/extensions/string";

import { PropsWithChildren, ReactElement, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { externalLink } from "core/links";
import { Platform, useMobilePlatform } from "core/hooks/useMobilePlatform";
import { useStatusModal } from "core/hooks/useStatusModal";
import { useTranslation } from "react-i18next";

interface FeatureToggleProps extends PropsWithChildren {
  showFeature: boolean;
  triggerUpdateModal?: boolean;
  backPath?: string;
}

export const FeatureToggle = ({ children, showFeature, triggerUpdateModal, backPath: backUrl }: FeatureToggleProps): ReactElement => {
  const { isMobileApp, platform } = useMobilePlatform();
  const { t } = useTranslation(undefined, { keyPrefix: "featureToggle" });
  const navigate = useNavigate();
  const { Modal, setBody } = useStatusModal("feature-toggle");

  let url = "#";
  switch (platform) {
    case Platform.android:
      url = process.env.REACT_APP_WISDOM_PLAYSTORE_URI!;
      break;
    case Platform.ios:
      url = process.env.REACT_APP_WISDOM_APPSTORE_URI!;
      break;
  }

  useEffect(() => {
    if (!showFeature && triggerUpdateModal) {
      setBody({
        data: {
          title: t("title"),
          description: t("description"),
          cta: t("cta"),
        },
        status: "info",
        cancelCallback: () => (backUrl ? navigate(backUrl) : navigate(-1)),
        callback: () => externalLink(url, false),
        ignoreHide: true,
      });
    }
  }, [backUrl, navigate, setBody, showFeature, t, triggerUpdateModal, url]);

  if (!showFeature && triggerUpdateModal && isMobileApp) {
    return <>{Modal}</>;
  }

  if (!showFeature && !triggerUpdateModal) {
    return <Navigate to="/not-found" />;
  }

  return <>{children}</>;
};
